import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  Text,
  Badge,
  Stack,
} from '@chakra-ui/react';
import { ITitleCategory, ITitleItem, ITitleSubmissionItem } from '../../../../services/hooks/TitleSubmissions/types';
import TitleItemCard from './TitleItemCard';

interface IOwnProps {
  category: ITitleCategory;
  submissionItems: ITitleSubmissionItem[];
  submissionId: string;
  isDraft: boolean;
}

const TitleCategoryAccordion: React.FC<IOwnProps> = ({
  category,
  submissionItems,
  submissionId,
  isDraft,
}) => {
  const categoryItems = submissionItems.filter((si: ITitleSubmissionItem) =>
    category.items.some((ci) => ci.id === si.title_item)
  );

  const partialScore = categoryItems.reduce((sum, si) => sum + (Number(si.declared_score) || 0), 0);

  return (
    <Accordion allowMultiple>
      <AccordionItem border="1px solid" borderColor="gray.200" borderRadius="md">
        <AccordionButton px={4} py={3} _hover={{ bg: 'gray.50' }}>
          <Flex flex={1} justify="space-between" align="center" wrap="wrap" gap={2}>
            <Text fontWeight="semibold" fontSize="sm" textAlign="left">
              {category.name}
            </Text>
            <Flex align="center" gap={2}>
              <Flex
                direction="column"
                align="flex-end"
                bg={partialScore > 0 ? 'green.50' : 'gray.50'}
                borderRadius="md"
                px={3}
                py={1}
                borderWidth="1px"
                borderColor={partialScore > 0 ? 'green.200' : 'gray.200'}
              >
                <Text fontSize="xs" color="gray.500" lineHeight="1.2">
                  Pontuação declarada
                </Text>
                <Flex align="baseline" gap={1}>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    color={partialScore > 0 ? 'green.600' : 'gray.500'}
                  >
                    {partialScore.toFixed(2)}
                  </Text>
                  <Text fontSize="xs" color="gray.400">
                    / {Number(category.max_score).toFixed(2)} pontuação máxima
                  </Text>
                </Flex>
              </Flex>
              {category.normalize && (
                <Badge colorScheme="purple" fontSize="xs">
                  Normalizado
                </Badge>
              )}
            </Flex>
          </Flex>
          <AccordionIcon ml={2} />
        </AccordionButton>
        <AccordionPanel pb={3} px={4}>
          <Stack spacing={2}>
            {category.items.length === 0 ? (
              <Box py={2}>
                <Text fontSize="sm" color="gray.500">
                  Nenhum item disponível nesta categoria.
                </Text>
              </Box>
            ) : (
              category.items
                .slice()
                .sort((a: ITitleItem, b: ITitleItem) => a.position - b.position)
                .map((item: ITitleItem) => {
                  const declaration = submissionItems.find((si) => si.title_item === item.id);
                  return (
                    <TitleItemCard
                      key={item.id}
                      item={item}
                      declaration={declaration}
                      submissionId={submissionId}
                      isDraft={isDraft}
                    />
                  );
                })
            )}
          </Stack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default TitleCategoryAccordion;
